import { Chip } from '@lifebit-ai/lds'
import React from 'react'

import type { FilterApiQueryOperators } from 'modules/cohort-browser/enums'

interface AggregationTagProps {
  aggregation?: FilterApiQueryOperators
}

export const AggregationTag = ({ aggregation }: AggregationTagProps): JSX.Element | null => {
  if (!aggregation) {
    return null
  }

  return <Chip withFixedWidth data-testid="aggregation-tag" content={[{ type: 'operator', value: aggregation }]} />
}
